// extracted by mini-css-extract-plugin
module.exports = {"crm":"_946e42d"};